import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {Button, Modal} from "react-bootstrap";
import {myService} from '@app/services/sukienService';
import {alertService} from '@app/services/alertService';
import {ClipLoader} from "react-spinners";
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";
import NhomsukienListComponent from "@pages/FUtil/NhomsukienListComponent";
import PhanloaisukienListComponent from "@pages/FUtil/PhanloaisukienListComponent";
import NhadanListComponent from "@pages/FUtil/NhadanListComponent";
import HinhthucListComponent from "@pages/FUtil/HinhthucListComponent";
import NewDatePicker from '@app/pages/FUtil/NewDatePicker';

const NhadanchitietEditModal = ({
                                    showModal,
                                    initialObj,
                                    allowEdit,
                                    onHide,
                                    onSuccess,
                                    parentId,
                                    isHeader
                                }) => {
    const [t] = useTranslation();
    const [loading, setLoading] = useState(false);

    const initial = {
        id : 0,
        nhadan_fk: null, // using component NhadanListComponent
        nhomsukien_fk: null, // using component: NhomsukienListComponent
        phanloaisukien_fk: null, // using component PhanloaisukienListComponent
        trangthaidotso_fk: null, // using component TrangthaiListComponent
        trangthaixinkeo_fk: null, // using component TrangthaiListComponent
        hinhthuc_fk: null, // using component HinhthucListComponent
        ngay_sac_phong: '', // input
        trangthaiketqua_fk: null, // using component TrangthaiListComponent
        ngay_su_kien_chi_tiet: '', // input
        ghi_chu: '' // textarea
    };

    const [obj, setObj] = useState(initialObj || {...initial});

    // Update obj when initialObj changes
    React.useEffect(() => {
        setObj(initialObj || {...initial});
    }, [initialObj]);

    const onChangeInput = (e) => {
        const {name, value, checked} = e.target;

        setObj((prevState) => {
            let newState = { ...prevState, [name]: value };
            /* if(name === 'coquan_fk')
             {
                 newState.nhomsukien_fk = "";
                 newState.phanloaisukien_fk = "";
             }*/
            if (name === "nhomsukien_fk") {
                newState.phanloaisukien_fk = "";
            }


            return newState;
        });
    };

    const handleModalSave = async () => {
        let data = obj;
        if (!data) {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }

        if (!data.nhadan_fk || data.nhadan_fk.length === 0) {
            alert('Vui lòng chọn nhà đàn');
            return;
        }

        if (!data.nhomsukien_fk || data.nhomsukien_fk.length === 0) {
            alert('Vui lòng chọn nhóm sự kiện');
            return;
        }

        if (!data.phanloaisukien_fk || data.phanloaisukien_fk.length === 0) {
            alert('Vui lòng chọn phân loại sự kiện');
            return;
        }

        if(data.id && data.id !== '0' && data.id !== 0 ) {
            await updateRecord(data);
        } else {
            await createRecord(data);
        }
    };

    async function createRecord(data) {
        setLoading(true);
        try {
            const result = await myService.Create_Nhadanchitiet(parentId, data);
            if (result.status === "1") {
                alertService.success(result.msg);
                onSuccess(); // Notify parent to refresh data
                onHide(); // Close modal
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            alertService.error('Có lỗi xảy ra khi tạo dữ liệu');
        }
        setLoading(false);
    }

    async function updateRecord(data) {
        setLoading(true);
        try {
            const result = await myService.Update_Nhadanchitiet(data.id, data);
            if (result.status === "1") {
                alertService.success(result.msg);
                onSuccess(); // Notify parent to refresh data
                onHide(); // Close modal
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            alertService.error('Có lỗi xảy ra khi cập nhật dữ liệu');
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <Modal size="xl" show={showModal} onHide={onHide}>
                <Modal.Body>
                    <div className="flex justify-center items-center h-40">
                        <ClipLoader color="#3498db" size={50} />
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <Modal size="xl" show={showModal} onHide={onHide}>
            <Modal.Header>
                <Modal.Title>
                    Thông tin nhà đàn chi tiết
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6">
                        <div className='form-group'>
                            <NhadanListComponent
                                nhadan_fk={obj.nhadan_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "nhadan_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                            />
                        </div>

                        <div className='form-group'>
                            <NhomsukienListComponent
                                nhomsukien_fk={obj.nhomsukien_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "nhomsukien_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                            />
                        </div>

                        <div className='form-group'>
                            <PhanloaisukienListComponent
                                nhomsukien_fk={obj.nhomsukien_fk}
                                phanloaisukien_fk={obj.phanloaisukien_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "phanloaisukien_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                            />
                        </div>

                        <div className='form-group'>
                            <TrangthaiListComponent
                                trangthai_fk={obj.trangthaidotso_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "trangthaidotso_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                                label = 'Đốt sở'
                                trangthaiName="dotso"
                                filterIds = { [0,1] }
                            />
                        </div>

                        <div className='form-group'>
                            <label className="required">Ngày sắc phong</label>
                            <NewDatePicker className="form-control w-100" isV2
                                           id="ngay_sac_phong" name="ngay_sac_phong" value={obj.ngay_sac_phong}
                                           onDayChange={onChangeInput} />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className='form-group'>
                            <TrangthaiListComponent
                                name="trangthaixinkeo_fk"
                                trangthai_fk={obj.trangthaixinkeo_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "trangthaixinkeo_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                                trangthaiName="xinkeo"
                                filterIds = { [0,1] }
                                label = 'Xin keo'
                            />
                        </div>

                        <div className='form-group'>
                            <HinhthucListComponent
                                value={obj.hinhthuc_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "hinhthuc_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                            />
                        </div>

                        <div className='form-group'>
                            <TrangthaiListComponent
                                trangthai_fk={obj.trangthaiketqua_fk}
                                onChange={(opt, e) => {
                                    const target = {name: "trangthaiketqua_fk", value: opt?.value};
                                    onChangeInput({target});
                                }}
                                trangthaiName="ketqua"
                                filterIds = { [0,1] }
                                label = 'Kết quả'
                            />
                        </div>

                        <div className='form-group'>
                            <label className="required">Ngày sự kiện chi tiết</label>
                            <NewDatePicker className="form-control w-100" isV2
                                           id="ngay_su_kien_chi_tiet"
                                           name="ngay_su_kien_chi_tiet" value={obj.ngay_su_kien_chi_tiet}
                                           onDayChange={onChangeInput} />
                        </div>

                        <div className='form-group'>
                            <label htmlFor="ghi_chu">Ghi chú</label>
                            <textarea
                                className="form-control"
                                name="ghi_chu"
                                rows="4"
                                value={obj.ghi_chu}
                                onChange={onChangeInput}
                                placeholder="Nhập ghi chú..."
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {"Thoát"}
                </Button>
                { allowEdit && (<Button variant="primary" onClick={handleModalSave}>
                    {"Xác nhận"}
                </Button>) }
            </Modal.Footer>
        </Modal>
    );
};

export default NhadanchitietEditModal;